import main from "../Components/About/img/main.webp";
import darth from "../Components/About/img/darth-vader.webp";
import grogu from "../Components/About/img/grogu.webp";
import hanSolo from "../Components/About/img/han-solo.webp";
import kyloRen from "../Components/About/img/kylo-ren.webp";
import leiaOrgana from "../Components/About/img/leia-organa.webp";
import lukeSkywalker from "../Components/About/img/luke-skywalker.webp";
import poe from "../Components/About/img/poe.webp";
import yoda from "../Components/About/img/yoda.webp";
import bb8 from "../Components/About/img/bb8.webp";

export const dataPosters = [
   {
      id: 1,
      poster: main,
   },

   {
      id: 2,
      poster: darth,
   },
   {
      id: 3,
      poster: grogu,
   },
   {
      id: 4,
      poster: hanSolo,
   },
   {
      id: 5,
      poster: kyloRen,
   },
   {
      id: 6,
      poster: leiaOrgana,
   },
   {
      id: 7,
      poster: lukeSkywalker,
   },
   {
      id: 8,
      poster: poe,
   },
   {
      id: 9,
      poster: yoda,
   },

   {
      id: 10,
      poster: bb8,
   },
];
